import { render, staticRenderFns } from "./EnrollColor.vue?vue&type=template&id=fe4ec36a&"
import script from "./EnrollColor.vue?vue&type=script&lang=js&"
export * from "./EnrollColor.vue?vue&type=script&lang=js&"
import style0 from "./EnrollColor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports